// Color choices for tags (stored in tags.color). Same palette as before the redesign.
export const PRESET_COLORS = [
  '#FF6B6B', '#4ECDC4', '#45B7D1', '#FFA07A', '#98D8C8',
  '#F7DC6F', '#BB8FCE', '#85C1E2', '#52C41A', '#1890FF',
  '#722ED1', '#EB2F96', '#FA8C16', '#13C2C2', '#2F54EB',
];

export const DEFAULT_TAG_COLOR = '#4ECDC4';
